import React from 'react';
import './MovieCard.css';

const MovieCard = ({ movie }) => {
  if (!movie) return null;

  const title = movie.Title || 'Untitled';
  const year = movie.Year || '';
  const rating = movie['IMDb Rating'];
  const runtime = movie['Runtime (mins)'];
  const genres = movie.Genres || '';
  const directors = movie.Directors || '';
  const posterUrl = movie['Poster Url'];

  return (
    <div className="movie-card">
      <div className="movie-card__poster">
        {posterUrl ? (
          <img src={posterUrl} alt={`${title} poster`} loading="lazy" />
        ) : (
          <div className="movie-card__no-poster">No Poster</div>
        )}
      </div>
      <div className="movie-card__info">
        <h3 className="movie-card__title">
          {title} {year && <span className="movie-card__year">({year})</span>}
        </h3>
        <div className="movie-card__meta">
          {rating && (
            <span className="movie-card__rating">
              <span className="star">&#9733;</span> {parseFloat(rating).toFixed(1)}
            </span>
          )}
          {runtime && <span className="movie-card__runtime">{runtime} min</span>}
        </div>
        {genres && <p className="movie-card__genres">{genres}</p>}
        {directors && <p className="movie-card__directors">Dir: {directors}</p>}
      </div>
    </div>
  );
};

export default MovieCard;
